// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nX5C","fullView":"styles_fullView__2cKRB"};